<template>
  <div class="outside_page_background" :style="dynamicCss"></div>
</template>

<script>
  import {extend} from "../../js/utils/objUtils";

  export default {
        name: "OutsidePageBackground",
        props: {
            url: {
                type: String,
                required: false
            },
            css: {
                type: Object,
                required: false,
                default: () => {
                    return {};
                }
            }
        },
      data() {
        return {
            defaultUrl: '/static/img/default_outside_bg.jpg'
        }
      },
        computed: {
            dynamicCss() {
              return extend({'background-image': 'url("' + (this.url ? this.url : this.defaultUrl) + '")'}, this.css)
            }
        }
    }
</script>

<style scoped>
  .outside_page_background {
    background-size: cover;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    position: fixed;
  }
</style>



// WEBPACK FOOTER //
// src/view/component/OutsidePageBackground.vue